import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=3c7663b4&scoped=true&"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js&"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=3c7663b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7663b4",
  null
  
)

export default component.exports